import React, { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Modal,
  Fade,
  Box,
  IconButton,
  Radio,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import TradingStyles from "./SegmentDetails.module.scss";
import TickCircle from "../../../Components/assets/Images/tick-circle.svg";
import EmptyCircle from "../../../Components/assets/Images/TickEmptyCircle.svg";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import BackDrop from "../../../Components/BackDrop";
import {
  SegmentStageDetailsAPICall,
  SegmentUpdateAPICall,
} from "../SegmentUpdateAPICalls";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import keyboardicon from "../../../Components/assets/Images/tradingicongrey.svg";
import { SaveIpAddressAPICall } from "../../../shared/APICalls";

const TradingPreferenceSchema = Yup.object().shape({
  Equity: Yup.boolean().oneOf([true], "Equity is required"),
});

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50vw",
  height: "90vh",
  bgcolor: "background.paper",
  p: 1,
  boxShadow: 24,
  overflowY: "scroll",
  borderRadius: "20px",
};

export default function SegmentDetails() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [segmentData, setSegmentData] = useState<any>([
    {
      sequence: 1,
      segmentName: "Equity",
      isOpted: true,
      segmentLink: "equity",
    },
    {
      sequence: 2,
      segmentName: "F&O",
      isOpted: false,
      segmentLink: "futures_and_options",
    },
    {
      sequence: 3,
      segmentName: "Mutual Funds",
      isOpted: true,
      segmentLink: "mutual_funds",
    },
    // {
    //   sequence: 5,
    //   segmentName: "Commodity",
    //   isOpted: false,
    //   segmentLink: "commodity",
    // },
    // {
    //   sequence: 4,
    //   segmentName: "Currency",
    //   isOpted: false,
    //   segmentLink: "currency",
    // },
  ]);
  const [completedStages, setCompletedStages] = useState<any>();
  const [prefilloading, setprefilloading] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [existingSegments, setExistingSegments] = useState({
    equity: true,
    futures_and_options: false,
    currency: false,
    commodity: false,
    mutual_funds: false,
  });

  const [prefillData, setprefillData] = useState<any>({
    equity: true,
    futures_and_options: true,
    currency: false,
    commodity: true,
    mutual_funds: true,
  });

  const requestID: any = sessionStorage.getItem("segmentRequestid");

  useEffect(() => {
    window.scrollTo(0, 0);

    let obj: any = {
      request_id: requestID,
      stage: "segment_details",
    };

    SegmentStageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        if (response.data.data.ErrMessage) {
          setRejectMessage(response.data.data.ErrMessage);
        }

        setprefilloading(false);
        setExistingSegments(responseData.data.data.existing_details);
        setprefillData((prev) => {
          return {
            ...prev,
            equity: responseData.data.data.new_details.equity,
            futures_and_options:
              responseData.data.data.new_details.futures_and_options,
            currency: responseData.data.data.new_details.currency_derivatives,
            commodity: responseData.data.data.new_details.commodities,
            mutual_funds: responseData.data.data.new_details.mutual_funds,
          };
        });
      })
      .catch((error: any) => {
        setprefilloading(false);
      });
  }, []);

  function segmentDetailsPost(data: any) {
    setloading(true);

    if (
      prefillData.futures_and_options === data[1].isOpted &&
      prefillData.mutual_funds === data[2].isOpted
    ) {
      seterrorMessage("Please select an option to continue further");
      setTimeout(() => {
        seterrorMessage("");
      }, 5000);
    } else {
      let objNew = {
        request_id: requestID,
        data: {
          equity: true,
          futures_and_options: data[1].isOpted,
          mutual_funds: data[2].isOpted,
        },
      };
      // console.log("objNew", objNew);
      SegmentUpdateAPICall(objNew).then((response: any) => {
        const responseData = response.data;
        if (response.data.data.request_id) {
          sessionStorage.setItem(
            "segmentRequestid",
            response.data.data.request_id
          );
        }

        SaveIpAddress(responseData);
      });
    }
  }

  const SaveIpAddress = (resposeData: any) => {
    let obj: any = {
      request_id: resposeData.data.request_id,
      update_component: "segments",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("latitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {
        if (resposeData.data.next_stage) {
          navigate(`/segmentUpdate/${resposeData.data.next_stage}`);
        }
      })
      .catch((error: any) => {});
  };

  const InitialValues = {
    equity: true,
    futures_and_options: prefillData.futures_and_options,
    // currency: !prefillData.currency,
    // commodity: prefillData.commodity,
    mutual_funds: prefillData.mutual_funds,
  };

  //console.log(selectedCheckboxes);

  const handleCheckBoxClick = (name: any, callback: any, values: any) => {
    callback(name, !values[name]);
  };

  return (
    <div className={TradingStyles.mainWrapper}>
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      <div className={TradingStyles.wrapper}>
        <div className={TradingStyles.step}>
          <img src={keyboardicon} /> Step 2 of 4
        </div>
        <div className={TradingStyles.headerSection}>
          <p className={TradingStyles.signup}>Choose Your Trading Preference</p>
        </div>
        {!prefilloading ? (
          <Formik
            initialValues={InitialValues}
            validationSchema={TradingPreferenceSchema}
            onSubmit={(values) => {
              // console.log("vlaue", values);

              const selectedSegments = segmentData
                .filter((segment: any) => values[segment.segmentLink])
                .map((segment: any) => ({
                  segmentName: segment.segmentName,

                  segmentLink: segment.segmentLink,
                }));

              const updatedSegmentData = segmentData.map((a: any) => {
                const isOpted = selectedSegments.some(
                  (b: any) => b.segmentLink === a.segmentLink
                );
                return { ...a, isOpted };
              });
              segmentDetailsPost(updatedSegmentData);
            }}
          >
            {({ errors, touched, handleSubmit, setFieldValue, values }) => {
              // console.log("errors", errors);
              return (
                <Form
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                  }}
                  style={{ width: "100%" }}
                >
                  <Stack style={{ width: "100%" }}>
                    <Stack
                      alignItems={"center"}
                      marginTop={"20px"}
                      style={{ width: "100%" }}
                    >
                      {segmentData.map((segment: any, index: any) => (
                        <div
                          className={TradingStyles.checkBoxFeild}
                          style={{
                            background: values[segment.segmentLink]
                              ? "#F9FAFB"
                              : "white",
                            border: values[segment.segmentLink]
                              ? "1px solid #E5E7EB"
                              : "1px solid #E5E7EB",
                          }}
                          key={segment.segmentLink}
                        >
                          <FormControlLabel
                            sx={{ marginRight: "10px", width: "100%" }}
                            control={
                              <Radio
                                icon={
                                  values[segment.segmentLink] === true ? (
                                    <img src={TickCircle} width={"24px"} />
                                  ) : (
                                    <img src={EmptyCircle} width={"24px"} />
                                  )
                                }
                                checkedIcon={
                                  values[segment.segmentLink] === "equity" ? (
                                    <img src={EmptyCircle} width={"24px"} />
                                  ) : (
                                    <img src={TickCircle} width={"24px"} />
                                  )
                                }
                                name={segment.segmentLink}
                                onClick={(e) => {
                                  if (segment.segmentLink !== "equity") {
                                    e.stopPropagation();
                                    handleCheckBoxClick(
                                      segment.segmentLink,
                                      setFieldValue,
                                      values
                                    );
                                  }
                                }}
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  position: "absolute",
                                  right: "10px",
                                }}
                                value={values[segment.segmentLink]}
                                checked={values[segment.segmentLink]}
                              />
                            }
                            label={
                              <div className={TradingStyles.text}>
                                <span>
                                  {" "}
                                  {segment.segmentName === "F&O"
                                    ? "F&O"
                                    : segment.segmentName}
                                </span>
                                <span className={TradingStyles.des}>
                                  Trade in Futures and Options
                                </span>
                              </div>
                            }
                            disabled={existingSegments[segment.segmentLink]}
                          />
                          {segment.segmentName === "Equity" && (
                            <span className={TradingStyles.defaultLabel}>
                              Default
                            </span>
                          )}
                        </div>
                      ))}
                      {/* </FormGroup> */}
                    </Stack>

                    <div className={TradingStyles.buttonStack}>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {existingSegments.equity &&
                        existingSegments.futures_and_options &&
                        existingSegments.mutual_funds ? (
                          <LoadingButton
                            id="tradingPreferencesContinueButton"
                            variant="contained"
                            disabled
                            // className={TradingStyles.approveButton}
                            sx={{ height: "50px", width: "max-content" }}
                          >
                            <span style={{ color: "black" }}>
                              {" "}
                              Your trading preference are upto date
                            </span>
                          </LoadingButton>
                        ) : (
                          <LoadingButton
                            id="tradingPreferencesContinueButton"
                            variant="contained"
                            // type="submit"
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={TradingStyles.approveButton}
                            sx={{ height: "50px" }}
                          >
                            Continue
                          </LoadingButton>
                        )}
                      </div>
                    </div>
                  </Stack>
                </Form>
              );
            }}
          </Formik>
        ) : (
          <div className={TradingStyles.wrapper}>
            <BackDrop />
          </div>
        )}
      </div>
    </div>
  );
}
